module.exports = __webpack_public_path__ + "img/microsilver_microbiome.ea07f937.jpg";